var map = {
	"./im1.jpg": 4773,
	"./im11.jpg": 7916,
	"./im12.jpg": 4363,
	"./im13.jpg": 9582,
	"./im14.jpg": 4053,
	"./im15.jpg": 1688,
	"./im16.jpg": 2263,
	"./im17.jpg": 1450,
	"./im18.jpg": 2593,
	"./im19.jpg": 4548,
	"./im2.jpg": 2170,
	"./im20.jpg": 9240,
	"./im3.jpg": 6007,
	"./im4.jpg": 4812,
	"./im5.jpg": 2857,
	"./im6.jpg": 9774,
	"./im7.jpg": 7611,
	"./im9.jpg": 4045,
	"./sagar.jpg": 7360,
	"./tejas.jpg": 9047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1012;